import { Component } from '@angular/core';  
import { LoaderService } from '../../services/loader.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-loader',
    imports: [MatProgressSpinnerModule],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  
  isLoaderOn = false;
  constructor(public loaderService: LoaderService){}

  ngOnInit(){
    this.loaderService.isLoaderOn.subscribe({next:(status: boolean) =>{
      this.isLoaderOn = status;
    }
  ,error: (err: any) => {}
});
  }
}
